import React from "react";
import { CompactPicker } from 'react-color';
import { dispatch } from '@rematch/core';

var color = require('./color.json');


class ColorPalette extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentWillMount() {

  }

  handleChangeComplete = (clr, event) => {
    this.props.selectedPracticeFlowCommunity.tagColor = clr.hex;
    dispatch.lifeCycle.setCommunityTagColor(this.props.selectedPracticeFlowCommunity);
    dispatch.createPack.editCommunityAsync(this.props.selectedPracticeFlowCommunity)
  };

  render() {

    let currentColor = color.join(',').split(',');
    let relatedCommunity = this.props.selectedPracticeLibrary.communities;


    if (relatedCommunity.length > 0) {
      for (let i = 0; i < relatedCommunity.length; i++) {
        let colorIndex = currentColor.indexOf(relatedCommunity[i].tagColor);

        if (colorIndex != -1) {
          currentColor.splice(colorIndex, 1)
        }

        if (relatedCommunity[i].communities.length > 0) {

          for (let j = 0; j < relatedCommunity[i].communities.length; j++) {
            let colorIndex2 = currentColor.indexOf(relatedCommunity[i].communities[j].tagColor);

            if (colorIndex2 != -1) {
              currentColor.splice(colorIndex2, 1)
            }
          }
        }
      }
    }
    return (
      <div style={{ maxHeight: '400px', overflow: 'auto' }}>
        <CompactPicker colors={currentColor} className="colorPallet" onChange={this.handleChangeComplete} />
      </div>
    );
  }
}
export default ColorPalette;
